import React from 'react'
import Cabins from './cabins.svg'
import Guests from './guests.svg'
import Length from './length.svg'
import styles from './styles.css'
import { ExperienceDetailsFragment } from '#src/generated/graphql'

interface FeatureProps {
  sellable: ExperienceDetailsFragment
}

const Features: React.SFC<FeatureProps> = ({ sellable }) => {
  const charterLengthFeet = sellable.charterLengthFeet
  const charterCapacity = sellable.charterCapacity
  const charterCabins = sellable.charterCabins

  if (!charterLengthFeet && !charterCapacity && !charterCabins) {
    return null
  }

  return (
    <div className={styles.container}>
      {charterLengthFeet && charterLengthFeet.formatted && (
        <div className={styles.feature}>
          <div>
            <Length className={styles.icon} />
          </div>
          <div className={styles.lengthCopy}>
            <div className={styles.label}>Length</div>
            <div className={styles.value}> {charterLengthFeet.formatted.displayHtml}</div>
          </div>
        </div>
      )}
      {charterCapacity && charterCapacity.formatted && (
        <div className={styles.feature}>
          <div className={styles.iconContainer}>
            <Guests className={styles.icon} />
          </div>
          <div className={styles.copy}>
            <div className={styles.label}>guests</div>
            <div className={styles.value}>{charterCapacity.formatted.displayHtml}</div>
          </div>
        </div>
      )}
      {charterCabins && charterCabins.formatted && (
        <div className={styles.feature}>
          <div className={styles.iconContainer}>
            <Cabins className={styles.icon} />
          </div>
          <div className={styles.copy}>
            <div className={styles.label}>cabins</div>
            <div className={styles.value}>{charterCabins.formatted.displayHtml}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Features
